import { ModelBase } from "@shoothill/core";
import { action, observable } from "mobx";

export class GenericIdWithDisplayName extends ModelBase<GenericIdWithDisplayName, GenericIdWithDisplayNameDTO> {
    // #region Constructors and Disposers
    // #endregion Constructors and Disposers

    // #region Defaults and Constants

    public static readonly DEFAULT_ID = "";
    public static readonly DEFAULT_DISPLAYNAME = "";

    // #endregion Defaults and Constants

    // #region Observables

    @observable
    public id: string = GenericIdWithDisplayName.DEFAULT_ID;

    @observable
    public displayName: string = GenericIdWithDisplayName.DEFAULT_DISPLAYNAME;

    // #endregion Observables

    // #region Actions

    @action
    public reset(): void {
        this.id = GenericIdWithDisplayName.DEFAULT_ID;
        this.displayName = GenericIdWithDisplayName.DEFAULT_DISPLAYNAME;
    }

    @action
    public fromDto(dto: GenericIdWithDisplayNameDTO): void {
        this.id = dto.id;
        this.displayName = dto.displayName;
    }

    public toDto() {
        throw new Error("Method not implemented.");
    }

    // #endregion Actions

    // #region Helpers

    public static fromDtos(dtos: GenericIdWithDisplayNameDTO[]): GenericIdWithDisplayName[] {
        const types: GenericIdWithDisplayName[] = [];

        for (const dto of dtos) {
            const model = new GenericIdWithDisplayName();

            model.fromDto(dto);
            types.push(model);
        }

        return types;
    }

    // #endregion Helpers
}

export interface GenericIdWithDisplayNameDTO {
    id: string;
    displayName: string;
}
